<template>
  <Modal
    :title="$t('movement.create.modalTitle')"
    name="ADD_BALANCE_MODAL"
    width="350"
    actions
  >
    <template v-slot:body>
      <h-loading v-if="isCustomerLoading" />

      <v-form
        v-show="!isCustomerLoading"
        v-model="valid"
        ref="addMovementForm"
        lazy-validation
      >
        <h6 class="text-uppercase grey--text">
          {{ $t('movement.create.availableBalance') }}
        </h6>
        <p class="body-2">
          {{ availableBalance }}
        </p>

        <h6 class="text-uppercase grey--text">
          {{ $t('movement.create.sendTo') }}
        </h6>
        <p class="body-2 mb-8">
          {{ customerName }}
        </p>

        <v-text-field
          v-model.lazy="value"
          v-money="catalogCurrency()"
          :label="$t('movement.create.value')"
          :rules="[rules.required]"
          hide-details="auto"
          class="amount mb-5"
          ref="price"
          outlined
        />

        <v-textarea
          v-model="description"
          :rules="[rules.required]"
          hide-details
          outlined
          :label="$t('movement.create.description')"
          class="amount mb-5"
          rows="3"
        />

        <v-autocomplete
          v-model="category"
          :label="$t('movement.label.category')"
          :items="categories"
          item-text="name"
          item-value="value"
          :rules="[rules.required]"
          @input="sortReasonsByCategory()"
          outlined
        />

        <v-autocomplete
          v-model="reason"
          :label="$t('movement.label.reason')"
          :items="reasons"
          item-text="name"
          item-value="value"
          :rules="[rules.required]"
          :disabled="!category"
          outlined
        />

      </v-form>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeModal('ADD_BALANCE_MODAL')"
        :disabled="isLoading"
        class="mr-5 grey--text"
        elevation="0"
        large
        text
      >
        {{ $t('movement.create.cancel') }}
      </v-btn>
      <v-btn
        @click="save"
        :loading="isLoading"
        color="primary"
        elevation="0"
        large
      >
        {{ $t('movement.create.confirmButton') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import HAmount from '@/components/app/HAmount'

// import { currency } from '@/util/enums'
import { mapGetters, mapActions } from 'vuex'
import { clearCurrency } from '@/util/helpers'
import { catalogMonetary } from '@/util/catalog'
import { required, minLength } from '@/util/errorHandling'
import { VMoney } from 'v-money'
import { categories, reasonsByCategory } from '@/components/movement/movementCategoriesAndReasons'
import { catalogCurrency } from '@/util/catalog'

export default {
  name: 'ModalAddBalance',

  directives: {
    money: VMoney
  },

  components: {
    Modal,
    HAmount,
  },

  computed: {
    ...mapGetters(['customer', 'isCustomerLoading']),

    availableBalance() {
      const amount = this.customer?.available_balance
      return catalogMonetary(amount ? amount : 0)
    },

    customerName() {
      return this.customer?.name
    }
  },

  methods: {
    ...mapActions([
      'closeModal',
      'addBalance',
      'fetchCustomer',
      'fetchCustomers',
      'showErrorMessage',
      'showSuccessMessage',
    ]),

    save() {
      if (!this.$refs.addMovementForm.validate()) return

      this.isLoading = true

      const body = {
        description: this.description,
        reason: this.reason,
        category: this.category,
        value: clearCurrency(this.value),
        real_estate_id: this.customer.id,
      }

      let message = ''
      if (body.value > 0) message = this.$t('movement.create.messages.balanceAdded', { value: this.value })
      else message = this.$t('movement.create.messages.balanceRemoved', { value: this.value })

      this.addBalance(body)
        .then(() => {
          this.closeModal('ADD_BALANCE_MODAL')
          this.showSuccessMessage(message)
          this.fetchCustomers()
          this.resetForm()
        })
        .catch(({data}) => this.showErrorMessage(data.message))
        .finally(() => this.isLoading = false)
    },

    resetForm() {
      this.description = ''
      this.value = 0
    },

    sortReasonsByCategory() {
      this.reasons = this.reasonsByCategory[this.category];
      this.reason = null;
    },
  },

  data() {
    return {
      valid: false,
      isLoading: false,

      value: 0,
      description: '',

      rules: {
        required,
        minLength,
      },

      categories: categories,
      reasonsByCategory: reasonsByCategory,
      reasons: [],
      category: null,
      reason: null,

      catalogCurrency,
      // currency,
    }
  },
}
</script>
